// extracted by mini-css-extract-plugin
module.exports = {"collection-item-list":"collection-item-list_collection-item-list__jUa9f"};